import { isAuthorizedUser, isWorkspaceOwner, isWsAdmin, isWsAssistant } from 'shared/hooks/use-user'
import type { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'
import type { CourseDataInterface } from '../types/course-interface'

export const isAdminOrOwnerOfCourse = (
  user: UnauthorizedUser | UserInterface | undefined,
  courseData: CourseDataInterface | undefined,
): boolean =>
  isAuthorizedUser(user) &&
  ((courseData?.owner.id === user.id && isWorkspaceOwner(user)) ||
    (courseData?.owner.id === user.workspaceOwner && (isWsAdmin(user) || isWsAssistant(user))))
